import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../helper/config';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  address: any;

  constructor(private http: HttpClient) { }


  data = { u_id: localStorage.getItem("u_id") }

  a(address) {
    this.address = address;
    console.log(this.address);
  }

  b() {
    this.address = this.address.buildingName + "," + this.address.colony + "," + this.address.landmark + "," + this.address.city + "," + this.address.pincode + ".";
    return this.address;
  }

  setData(data) {
    console.log(data, 28);
    this.data = data
  }
  getData() {
    let tempararydata = this.data;
    return tempararydata;
  }

  address_list(data): Observable<any> {
    return this.http.post(config.api + 'products/address_list', data);
  }

  product_list(): Observable<any> {
    return this.http.get(config.api + 'products');
  }

  buyNow(data): Observable<any> {
    return this.http.post(config.api + 'products/addToCart', data);
  }

  addToCart(data): Observable<any> {
    console.log(data, 33);
    return this.http.post(config.api + "products/addToCart", data);
  }

  productById(data): Observable<any> {
    console.log(data);
    return this.http.post(config.api + 'products/productById', data);
  }


  availableCart(): Observable<any> {
    return this.http.get(config.api + 'products/availableCart');
  }

  delete(data): Observable<any> {
    console.log(data);
    return this.http.post(config.api + "products/deleteProduct", data)
  }

  editAddress(data): Observable<any> {
    console.log(data);
    return this.http.post(config.api + "products/editAddress", data)
  }
  deleteAddress(data): Observable<any> {
    console.log(data);
    return this.http.post(config.api + "products/deleteAddress", data)
  }

}
